import { UPDATE_FIELD_REGISTRY, UPDATE_FIELD_REGISTRY_SUCCESS, UPDATE_FIELD_REGISTRY_ERROR, UPDATE_FIELD_REGISTRY_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateFieldRegistry = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FIELD_REGISTRY:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_FIELD_REGISTRY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_FIELD_REGISTRY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_FIELD_REGISTRY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateFieldRegistry;
